module.exports = __webpack_public_path__ + "img/hot-espresso.86bc9b6a.jpg";